import contacts from './contacts';

export default contacts;